module.exports = __webpack_public_path__ + "static/pitch_logo-35fac512ae8aa619f1e47bc38533125e.png";